import { render } from "./ShiftCalendar.vue?vue&type=template&id=c61e90fe"
import script from "./ShiftCalendar.vue?vue&type=script&lang=js"
export * from "./ShiftCalendar.vue?vue&type=script&lang=js"

import "./ShiftCalendar.vue?vue&type=style&index=0&id=c61e90fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__